import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';
import { GetServiceCaller } from '../../../services/serviceCaller';
import { API_URL } from '../../../constants';
import moment from 'moment';
import Dynamic_PR_table from '../../../components/Dynamic_PR_table';

const PurchaseSummary = () => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Purchase Summary"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [PurchaseReportData, setPurchaseReportData] = useState([]);
    const [assetTypeOption, setAssetTypeOption] = useState([])
    const [grandTotal, setGrandTotal] = useState(0)
    const [categoryTypeOption, setCategoryTypeOption] = useState([])
    const [loading, setLoading] = useState(true);

    const columns = {

        PurchaseDate: { text: "Purchase Date", align: "center", visible: true },
        name: { text: "Assets", visible: true },
        CategoryName: { text: "Category", visible: true },
        Brand: { text: "Make", align: "start", visible: true },
        Description: { text: "Description", align: "left", visible: true },
        WarrantyDate: { text: "Waranty Date ", align: "center", visible: true },
        InvoiceNumber: { text: "Invoice No.", align: "start", visible: true },
        VendorName: { text: "Vendor", visible: true },
        AssetPrice: { text: "Price", align: "end", visible: true },
        ID: { text: "ID", align: "left", visible: false },
        Model: { text: "Model", align: "left", visible: false },

    };

    useEffect(() => {
        fetchGetPurchaseSummaryReport();
    }, []);

    const [apiStatus, SetApiStatus] = useState(undefined);

    const fetchGetPurchaseSummaryReport = async () => {
        SetApiStatus(undefined)
        try {
            const response = await GetServiceCaller(`${API_URL}support-desk-reports/5?P_AssetType=0&P_CategoryID_1160=0&P_FromDate=0&P_ToDate=0`);
            if (response.status === 200) {
                SetApiStatus(response?.status);
                const cleanedData = response?.data?.data;
                setPurchaseReportData(cleanedData);
                setGrandTotal(response?.data?.total?.[0]?.Grandtotal)
                const assetList = Object.entries(response?.data?.AssetType || {}).map(([key, value]) => ({
                    value: parseInt(key, 10), // Convert key to a number
                    label: value,
                }));

                setAssetTypeOption(assetList)
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Summary Report. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Summary Report:", error);
        }
    };


    const [filterFormData, setFilterData] = useState([]);
    useEffect(() => {
        const assetType = filterFormData.find((o) => o.label === "Asset Type")?.value;

        // Explicitly check for `undefined` or `null` instead of falsy values like 0
        if (assetType !== undefined && assetType !== null) {
            fetchGetCategoryDetails(assetType);
            setCategoryTypeOption([]); // Clear category options while fetching new data
        }
    }, [filterFormData]);

    const fetchGetCategoryDetails = async (id) => {
        try {
            const queryParams = new URLSearchParams({
                AssetType: id,
            });
            const response = await GetServiceCaller(`${API_URL}get-asset-categories?${queryParams.toString()}`);
            if (response.status === 200) {
                const fetchData = response?.data?.data;
                const categoryList = fetchData?.map((ele, index) => ({
                    value: ele?.ID,
                    label: ele?.CategoryName
                }))


                setCategoryTypeOption(categoryList)

                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch model masters. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("An error occurred while fetching brand details:", error);
        }
    };

    const formDatas = [
        {
            name: "From Date",
            type: "Date",
            // options: [...assetTypeOption]

        },
        {
            name: "To Date",
            type: "Date",
            // options: [...assetTypeOption]

        },
        {
            name: "Asset Type",
            type: "Select",
            placeHolderText: "Select",
            options: [...assetTypeOption],
        },
        {
            name: "Category",
            type: "Select",
            placeHolderText: "Select",
            options: [...categoryTypeOption || []],
        },

    ];


    const handleFilterChange = (e, name) => {
        setFilterData((prevFormData) => {
            // Check if the label already exists
            const existingLabelIndex = prevFormData.findIndex(
                (item) => item.label === name
            );

            // If the label exists, update its value
            if (existingLabelIndex !== -1) {
                const updatedFormData = prevFormData.map((item, index) =>
                    index === existingLabelIndex
                        ? { ...item, value: e.value !== undefined ? e.value : e }
                        : item
                );
                return updatedFormData;
            } else {
                // If the label doesn't exist, add a new label-value pair
                return [
                    ...prevFormData,
                    {
                        label: name,
                        value: e.value !== undefined ? e.value : e, // Assuming e is an event object
                    },
                ];
            }
        });
    };
    const handleGetData = async () => {
        try {
            const response = await GetServiceCaller(
                `${API_URL}support-desk-reports/5?P_AssetType=${filterFormData.find((o) => o.label === "Asset Type")
                    ? filterFormData.find((o) => o.label === "Asset Type").value
                    : 0
                }&P_CategoryID_1160=${filterFormData.find((o) => o.label === "Category")
                    ? filterFormData.find((o) => o.label === "Category").value
                    : 0
                }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
                    ? moment(filterFormData.find((o) => o.label === "From Date").value).format("YYYY-MM-DD")
                    : 0
                }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
                    ? moment(filterFormData.find((o) => o.label === "To Date").value).format("YYYY-MM-DD")
                    : 0
                }`
            );



            SetApiStatus(response?.status);
            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setPurchaseReportData(cleanedData);
                setGrandTotal(response?.data?.total?.[0]?.Grandtotal)
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Disposed Report. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Disposed Report:", error);
        }
    };


    const handleReset = () => {
        setFilterData([])
        fetchGetPurchaseSummaryReport()
    }


  const ReadOnlyValues = [
    { label: " Total", value:`₹ ${ Number(grandTotal).toLocaleString("en-IN")}`},
  ]
    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={PurchaseReportData}
                            columns={columns}
                            itemsPerPage={10}
                            handleReset={handleReset}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            ReadOnlyValues={ReadOnlyValues}
                            showIcon1={true}
                            showIcon2={false}
                            formDatas={formDatas}
                            isSorting={true}
                            filterFormData={filterFormData}
                            handleGetData={handleGetData}
                            isFilterRequired={true}
                            isActionRequired={false}
                            isAddNewBtnRequired={false}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            handleChange={handleFilterChange}
                            // handleIcon1={handleEdit}
                            // handleAddNew={handleAddNewVendor}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default PurchaseSummary